module.exports = __webpack_public_path__ + "img/faq.d26e6ccb.svg";